import { render, staticRenderFns } from "./header-view.vue?vue&type=template&id=f67f1dae&scoped=true&"
import script from "./header-view.vue?vue&type=script&lang=js&"
export * from "./header-view.vue?vue&type=script&lang=js&"
import style0 from "./header-view.vue?vue&type=style&index=0&id=f67f1dae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67f1dae",
  null
  
)

export default component.exports